// This file only contains those Txp constants which are being added to owa boot.
// Rest of the TXP constants are in TxpCommonConstants.
export const FLIGHTS_ENTITY_NAMES_MAP_VALUE = 1;
export const PACKAGE_ENTITY_NAMES_MAP_VALUE = 16;
